import * as React from 'react';
import { SVGProps } from 'react';

const IconPriceLabelStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M11.52 2.989a1.49 1.49 0 1 1 0 2.982 1.49 1.49 0 0 1 0-2.982Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.997 1C14.55 1 15 1.45 15 2.003v5.54c0 .266-.106.522-.294.71l-6.454 6.453a1.003 1.003 0 0 1-1.418 0l-5.54-5.54a1.003 1.003 0 0 1 0-1.419l6.453-6.454c.164-.165.38-.265.61-.288L8.456 1h5.54Zm0 1.003v5.54l-6.454 6.454-5.54-5.54 6.453-6.454h5.54Z"
    />
  </svg>
);
export default IconPriceLabelStrokedSizeS;
